import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import temporaryAuthReducer from './slices/temporaryAuthSlice';
import chatReducer from './slices/chatSlice';
import conversationReducer from './slices/conversationSlice';
import journalReducer from './slices/journalSlice';
import surveyReducer from './slices/surveySlice';
import subscriptionReducer from './slices/subscriptionSlice';
import visitorReducer from './slices/visitorSlice';
import inviteReducer from './slices/inviteSlice';
import organizationReducer from './slices/organizationSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    temporaryAuth: temporaryAuthReducer,
    chat: chatReducer,
    conversation: conversationReducer,
    journal: journalReducer,
    survey: surveyReducer,
    subscription: subscriptionReducer,
    visitor: visitorReducer,
    invite: inviteReducer,
    organization: organizationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
